<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar" /> 生产管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-form ref="searchform" :model="searchform" label-width="110px" @keyup.enter.native="search()">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="发货仓库编码" prop="outWarehouseCode">
                                <el-select v-model.trim="searchform.outWarehouseCode" placeholder="请输入仓库名称"
                                    style="width:100%" filterable>
                                    <el-option v-for="item in pagewarehouse" :key="item.warehouseCode"
                                        :label="item.warehouseName" :value="item.warehouseCode" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="收货仓库编码" prop="inWarehouseCode">
                                <el-select v-model.trim="searchform.inWarehouseCode" placeholder="请输入仓库名称"
                                    style="width:100%" filterable>
                                    <el-option v-for="item in pagewarehouse" :key="item.warehouseCode"
                                        :label="item.warehouseName" :value="item.warehouseCode" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="状态" prop="status">
                                <el-select style="width: 100%;" v-model="searchform.status" placeholder="请选择状态">
                                    <el-option label="待出库" :value="0"></el-option>
                                    <el-option label="出库中" :value="1"></el-option>
                                    <el-option label="部分出库" :value="2"></el-option>
                                    <el-option label="已完成" :value="3"></el-option>
                                    <el-option label="已取消" :value="4"></el-option>
                                    <el-option label="PDA已完成" :value="5"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="时间" prop="datelist">
                                <el-date-picker v-model="searchform.datelist" style="width: 100%" type="daterange"
                                    value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期"
                                    end-placeholder="结束日期" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="调拨单号" prop="transferOrderNo">
                                <el-input v-model.trim="searchform.transferOrderNo" placeholder="请输入调拨单号"
                                    style="width:100%" clearable />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" :offset="1">
                            <el-button v-permission="['transferOutOrder_select']" type="primary" icon="el-icon-search"
                                @click="search()">搜索
                            </el-button>
                            <el-button @click="resetForm('searchform')">重置</el-button>
                            <el-button v-permission="['transferOutOrder_add']" type="primary"
                                @click="addOrder()">新增出库</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <br />
            <transferOutOrderAdd ref="transferOutOrderAdd" :add="add" :search="search" />
            <br />
            <el-row type="flex" class="row-bg">
                <el-col :span="24" class="border">
                    <h4>{{ $route.meta.title }}</h4>
                    <el-divider></el-divider>
                    <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData"
                        style="width: 100%" id="parent">
                        <el-table-column prop="transferOrderNo" label="调拨单号" min-width="150" show-overflow-tooltip>
                            <template slot-scope="scope"><span class="linkClass"
                                    @click="getDetailList(scope.row.transferOrderNo)">{{ scope.row.transferOrderNo
                                    }}</span></template>
                        </el-table-column>
                        <el-table-column prop="creator" label="建单人" min-width="70" show-overflow-tooltip />
                        <el-table-column prop="outWarehouseName" label="发货仓库" min-width="150" show-overflow-tooltip />
                        <el-table-column prop="inWarehouseName" label="收货仓库" min-width="150" show-overflow-tooltip />
                        <el-table-column prop="outWarehouseCode" label="发货仓库编码" min-width="100" show-overflow-tooltip />
                        <el-table-column prop="inWarehouseCode" label="收货仓库编码" min-width="100" show-overflow-tooltip />
                        <el-table-column prop="transferDate" label="调拨日期" min-width="100" show-overflow-tooltip>
                            <template slot-scope="scope">{{ $parseTime(scope.row.transferDate).slice(0, 10) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="pdaFinishTime" label="PDA完成时间" min-width="100" show-overflow-tooltip />
                        <el-table-column prop="trackingNo" label="运单号" min-width="140" show-overflow-tooltip />
                        <el-table-column prop="statusDesc" label="单据状态" min-width="80" show-overflow-tooltip />
                        <!-- <el-table-column prop="syncTraceStatusDesc" label="状态" min-width="80" show-overflow-tooltip /> -->
                        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip />
                        <el-table-column min-width="230" label="操作" fixed="right">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.status == 0" v-permission="['transferOutOrder_update']"
                                    type="primary" @click="handleUpdata(scope.row)"> 编辑</el-button>
                                <el-button v-if="scope.row.status == 0" v-permission="['transferOutOrder_update']"
                                    type="primary" @click="handleType(scope.row, 1)"> 确认调拨</el-button>
                                <el-button v-if="scope.row.status == 1" v-permission="['transferOutOrder_update']"
                                    type="primary" @click="handleType(scope.row, 2)"> 取消调拨</el-button>
                                <el-button v-if="scope.row.status == 1" v-permission="['transferOutOrder_update']"
                                    type="primary" @click="handleType(scope.row, 3)"> 完成调拨</el-button>
                                <el-button v-if="scope.row.status != 3 " v-permission="['transferOutOrder_delete']"
                                    type="danger" @click="deletedate(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <br />
                    <el-pagination background :current-page.sync="currentPage" :page-sizes="[10, 20, 40, 100]"
                        layout="total,prev, pager, next,jumper,sizes" :total="total_count"
                        @current-change="currentchange" @size-change="pagesize" />
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import {
    transferList,
    transferDelete, transferCancel, transferConfirm, transferComplete, transferDetail
} from "@/api/production";
import transferOutOrderAdd from "./components/transferOutOrderAdd";
import { pagewarehouse } from "@/api/query";
export default {
    name: "transferOutOrder",
    components: { transferOutOrderAdd },
    data() {
        return {
            pagewarehouse: [],
            show: false,
            // 基础数据
            add: {
                addshow: false,
            },
            orderNo: "",
            listLoading: false,
            tableData: [],
            // 分页数据
            pagesizes: "",
            total_count: 1,
            currentPage: 1,
            searchform: {
                product_code: null,
                batchNo: "",
                orderNo: "",
                transferOrderNo: "",
                datelist: [],
                status: null,
                pageIndex: 1,
                pageSize: 10,
                erp_id: null,
            },
            statusList: ['待出库', '出库中', '部分出库', '已完成', '已取消', 'PDA已完成']
        };
    },
    mounted() {
        // 请求部门列表数据并且便利到表格
        this.search();
        this.getList();
    },
    methods: {
        Tabledata(obj) {
            // 列表获取
            this.listLoading = true;
            transferList(obj).then((response) => {
                const list = response.data.items;
                this.tableData = list.map(item => {
                    return {
                        ...item,
                        detailList: JSON.parse(item.detailList),
                        pdaFinishTime: item.pdaFinishTime ? this.$parseTime(item.pdaFinishTime).slice(0, 10) : null
                    }
                })
                this.currentPage = response.data.page_index;
                this.total_count = response.data.total_count;
                this.listLoading = false;
            });
        },
        // 搜索事件
        search() {
            const params = this.searchform
            params.plan_date = this.searchform.plan_date ? null : this.searchform.plan_date
            params.startDate =
                this.searchform.datelist == null ? null : this.searchform.datelist[0]
            params.endDate =
                this.searchform.datelist == null ? null : this.searchform.datelist[1]
            this.Tabledata(params);
        },
        // 重置按钮
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.search()
        },
        // 分页跳转事件
        currentchange(page_index) {
            this.searchform.pageIndex = page_index;
            const params = this.searchform
            params.plan_date = this.searchform.plan_date ? null : this.searchform.plan_date
            this.Tabledata(params);
        },
        // 分页每页显示条数事件
        pagesize(page_size) {
            this.searchform.pageSize = page_size;
            this.search();
        },
        async getList() {
            const params = {
                pageIndex: 1,
                pageSize: 999,
            }
            const { data } = await pagewarehouse(params)
            this.pagewarehouse = data.list
        },
        handleType(row, type) {
            if (type == 1) {
                this.$confirm('是否确认调拨出库该单, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    transferConfirm({ transferOrderNo: row.transferOrderNo }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '执行成功!'
                        });
                        this.search()
                    })
                })
            } else if (type === 2) {
                this.$prompt('请输入取消原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPlaceholder: '请填写取消原因',
                    inputValidator: (value) => {
                        if (!value) {
                            return '请填写取消原因';
                        }
                    },
                }).then(({ value }) => {
                    const parms = {
                        remark: value,
                        transferOrderNo: row.transferOrderNo
                    }
                    transferCancel(parms).then(res => {
                        this.$message({
                            type: 'success',
                            message: '取消成功!'
                        });
                        this.search()
                    })
                })
            } else if (type === 3) {
                this.$prompt('请输入实际调拨总数量', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValidator: (value) => {
                        if (!value) {
                            return '请填写实际调拨总数量';
                        }
                    },
                }).then(({ value }) => {
                    const parms = {
                        actualTotalQuantity: value,
                        transferOrderNo: row.transferOrderNo
                    }
                    transferComplete(parms).then(res => {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        this.search()
                    })
                })
            }
        },
        //编辑
        handleUpdata(row) {
            this.$refs.transferOutOrderAdd.resetForm()
            transferDetail({ transferOrderNo: row.transferOrderNo }).then(res => {
                this.$refs.transferOutOrderAdd.form = res.data
                this.$refs.transferOutOrderAdd.tablelist = res.data.detailList
                this.add.addshow = !this.add.addshow
            })

        },
        addOrder() {
            this.$refs.transferOutOrderAdd.resetForm()
            this.$refs.transferOutOrderAdd.tablelist = []
            this.add.addshow = !this.add.addshow
        },
        // 删除按钮事件
        deletedate(row) {
            this.$confirm("此操作将永久删除该工单信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    transferDelete({ transferOrderNo: row.transferOrderNo }).then((response) => {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.search();
                    });
                })
        },
        getDetailList(transferOrderNo) {
            this.$refs.transferOutOrderAdd.getDetailList(transferOrderNo)
        }
    },
};
</script>
<style scoped>
.rightclass {
    z-index: 9999;
}

.bottstycz {
    display: block !important;
    width: 150px;
    margin: 5px;
}

.linkClass {
    color: rgb(24, 144, 255);
    cursor: pointer;
}
</style>